import { CrudFilter } from 'admin';
import { useTradeIDQueryParams } from 'api';

export const useFindTicketsFilters = (): CrudFilter[] => {
  const { companyId, dealId, inspectionId, loadName, purchaseOrderSlug, salesOrderSlug, shipmentName } =
    useTradeIDQueryParams();

  return [
    {
      field: 'company_id',
      operator: 'eq',
      value: companyId,
    },
    {
      field: 'deal_id',
      operator: 'eq',
      value: dealId,
    },
    {
      field: 'inspection_id',
      operator: 'eq',
      value: inspectionId,
    },
    {
      field: 'load_name',
      operator: 'eq',
      value: loadName,
    },
    {
      field: 'purchase_order_slug',
      operator: 'eq',
      value: purchaseOrderSlug,
    },
    {
      field: 'sales_order_slug',
      operator: 'eq',
      value: salesOrderSlug,
    },
    {
      field: 'shipment_name',
      operator: 'eq',
      value: shipmentName,
    },
  ];
};
